// ky serialises every searchParams entry, so drop the absent ones rather than sending `?cursor=undefined`
export const withoutUndefined = (params: object): Record<string, string> =>
  Object.fromEntries(
    Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== '')
      .map(([key, value]) => [key, String(value)]),
  );
